import banner1 from './images/banner1.png';
import banner2 from './images/banner2.png';
import { FormattedMessage } from '../../util/reactIntl';
import React from 'react';

export const data = [
  {
    title: <FormattedMessage id="Banner.title1" />,

    subTitle: <FormattedMessage id="Banner.subTitle1" />,

    img: banner1,
    email: true,
  },
  {
    title: <FormattedMessage id="Banner.title2" />,
    subTitle:  <FormattedMessage id="Banner.subTitle2" />,
    img: banner2,
    link: true,
  }
];
